import './bootstrap';
import {initUsersIndex} from "./users";
import {initUsersCreate} from "./users/create";
import {initUsersEdit} from "./users/edit";
import {afterComponentLoadBootstrap} from "./bootstrap";
import {registerDevelopmentComponents} from "./development/registerDevelopmentComponents";
import {initOrdersIndex} from "./orders";
import {initEmailTemplatesIndex} from "./settings/emails";
import {initTemplatesIndex} from "./settings/templates";
import {initSiteSettingsIndex} from "./settings/site";

const componentMap = {
	'admin.users.index': {
		action: initUsersIndex,
	},
	'admin.users.create': {
		action: initUsersCreate,
	},
	'admin.users.edit': {
		action: initUsersEdit,
	},

	'admin.orders.index': {
		action: initOrdersIndex,
	},

	// Settings

	'admin.settings.emails.index': {
		action: initEmailTemplatesIndex
	},
	'admin.settings.templates.index': {
		action: initTemplatesIndex
	},
	'js/admin.settings.site.index': {
		action: initSiteSettingsIndex
	},
};

// Register development components
registerDevelopmentComponents(componentMap);

document.addEventListener('DOMContentLoaded', () => {
	// Init components
	// noinspection JSUnresolvedReference
	if (window.jsComponents) {
		window.jsComponents.forEach(componentKey => {
			if (componentMap[componentKey]) {
				try {
					componentMap[componentKey].action();
				} catch (e) {
					console.log(`Error running component ${componentKey}`);
					console.error(e);
				}
			} else {
				console.error(`"${componentKey}" component not found`);
			}
		})
	}

	afterComponentLoadBootstrap()
})

